import React, { useContext, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import Select from 'react-select';
import PropTypes from 'prop-types';
import { customStyle } from 'helper';
import { ModalContext } from 'App';
import * as actions from '../action';

function CreateModal({
  createInput,
  createMiniProgramGov,
  formData,
  setFormData,
  getMiniProgramGovList,
  history,
  showMiniProgramGov,
}) {
  const setModal = useContext(ModalContext);

  const govTypeList = [{label: 'NATIONAL', value: 'NATIONAL'}, {label: 'LGU', value:'LGU'}]

  const [govType, setGovType] = useState({
    label: '',
    value: '',
  })

  const handleOnSubmit = (e) => {
    e.preventDefault();
    createMiniProgramGov(formData, ({ data }) => {
      setModal({ isOpen: false });
      getMiniProgramGovList();
      history.push(`/general-settings/mini-program-government/${_.get(data, 'id')}`);
      showMiniProgramGov(data.id);
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const handleTypeSelect = e => {
    setGovType(e);
    setFormData({
      ...formData,
      type: e.value
    })
  }

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Name:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'icon_url', label: 'Icon:' },
              { required: true, minLength: 3 }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'sequence', label: 'Sequence:' },
              { required: true, type: 'number' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'description', label: 'Description:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'redirect_url', label: 'Redirect URL:' },
              { minLength: 3, required: true }
            )}
          </div>
          <div className="col-12 form-group">
            <label className="form-label">Government Type:</label>
            <Select
              options={govTypeList}
              styles={customStyle}
              placeholder="Select Type"
              value={govType}
              onChange={e => {
                handleTypeSelect(e);
              }}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Is Active: &nbsp;
            </label>
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button type="submit" className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3">
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  getMiniProgramGovList: PropTypes.instanceOf(Function).isRequired,
  createMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  showMiniProgramGov: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
